import axios from 'axios'
import { ConsignmentResponse, CreateOrUpdateConsignmentRequest } from '../../../../api/models'
import { ConsignmentSummaryResponse } from '../../../../api/models/consignment-summary-response'
import { GrossMassValidationResponse } from '../../../../api/models/gross-mass-validation-response'

const apiUrl = process.env.REACT_APP_API_URL

const apiConfig = {
  v2: {
    baseUrl: `${apiUrl}/v2/consignment`,
  },
  v3: {
    baseUrl: `${apiUrl}/v3/consignment`,
  },
}

export async function fetchConsignmentV2(params: { transitOperationId: number }, opts?: { signal?: AbortSignal }) {
  const { data } = await axios.get<ConsignmentResponse>(`${apiConfig.v2.baseUrl}/${params.transitOperationId}`, {
    signal: opts?.signal,
  })

  return data
}

export async function createConsignmentV2(request: CreateOrUpdateConsignmentRequest) {
  const { data } = await axios.post<ConsignmentResponse>(`${apiConfig.v2.baseUrl}`, request)

  return data
}

export async function createConsignmentDraftV2(request: CreateOrUpdateConsignmentRequest) {
  const { data } = await axios.post<ConsignmentResponse>(`${apiConfig.v2.baseUrl}/draft`, request)

  return data
}

export async function updateConsignmentV2(id: number, request: CreateOrUpdateConsignmentRequest) {
  const { data } = await axios.put<ConsignmentResponse>(`${apiConfig.v2.baseUrl}/${id}`, request)

  return data
}

export async function updateConsignmentDraftV2(id: number, request: CreateOrUpdateConsignmentRequest) {
  const { data } = await axios.put<ConsignmentResponse>(`${apiConfig.v2.baseUrl}/${id}/draft`, request)

  return data
}

export async function fetchConsignmentSummaryV3(id: number) {
  const { data } = await axios.get<ConsignmentSummaryResponse>(`${apiConfig.v3.baseUrl}/${id}/summary`)

  return data
}

export async function validateGrossMassV3(id: number) {
  const { data } = await axios.get<GrossMassValidationResponse>(`${apiConfig.v3.baseUrl}/${id}/validation/gross-mass`)

  return data
}
